var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "component" }, [
    _c("div", { staticClass: "tab_focus" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm.focus
        ? _c(
            "div",
            { staticClass: "focus-content-box" },
            _vm._l(_vm.componentData, function(item) {
              return _c("div", { staticClass: "focus-content" }, [
                _c(
                  "div",
                  { staticClass: "tag-focus" },
                  [
                    _c("portrait-labels", {
                      attrs: { labelList: _vm.convert(item.prominentName) }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "tag-content" }, [
                  _vm._v(_vm._s(item.prominentDesc))
                ])
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.focus
        ? _c("div", { staticClass: "noData" }, [_vm._v("暂无数据")])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "focus-title" }, [
      _c("span", { staticStyle: { margin: "4px 6px 0 0" } }, [
        _c("span", { staticClass: "kdfont kdfont-zhinengbiaoqian" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title-content" }, [_vm._v("简历关注点")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }